<script setup>
  import ProForecastSpotTileActionLink from '@/components/ProForecastSpotTitleActionLink.vue';
  import ProForecastSpotTitleActionWebviewButton from './ProForecastSpotTitleActionWebviewButton.vue';
  
  const props = defineProps({
    spotId: {
      type: [String, Number],
      required: true
    },
    webView: {
      type: Boolean,
      default: false
    }
  });

</script>

<template>
  <ProForecastSpotTitleActionWebviewButton
    v-if="props.webView"
    :spotId="props.spotId"
  >
    <slot></slot>
  </ProForecastSpotTitleActionWebviewButton>
  <ProForecastSpotTileActionLink
    v-else
    :spotId="props.spotId"
  >
    <slot></slot>
  </ProForecastSpotTileActionLink>
</template>